import { render, staticRenderFns } from "./serv-top-list.vue?vue&type=template&id=08b2ebec&scoped=true&"
import script from "./serv-top-list.vue?vue&type=script&lang=js&"
export * from "./serv-top-list.vue?vue&type=script&lang=js&"
import style0 from "./serv-top-list.vue?vue&type=style&index=0&id=08b2ebec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b2ebec",
  null
  
)

export default component.exports